export default __webpack_public_path__ + "static/media/Selected_Juggler.43dc2b28.svg";